import { Easing } from "@tweenjs/tween.js"
import Timings from "game/Timings"
import {
    DRIFT_ROTATION_RADIANS,
    DRIFT_TARGET,
    HALF_SEPARATION_DISTANCE,
    SEPARATION_DISTANCE
} from "./settings"

const {
    ROCKET_STAGE_DRIFT_DURATION,
    ROCKET_STAGE_SEPARATION_DELAY,
    ROCKET_STAGE_SEPARATION_DURATION
} = Timings

export function getSeparation(rocket) {
    const { firstStage, secondStage, thirdStage } = rocket

    const sharedProperties = {
        delay: ROCKET_STAGE_SEPARATION_DELAY,
        duration: ROCKET_STAGE_SEPARATION_DURATION,
        easing: Easing.Exponential.Out
    }

    const props3 = { y: thirdStage.y - HALF_SEPARATION_DISTANCE }
    const props2 = { y: secondStage.y - HALF_SEPARATION_DISTANCE }
    const props1 = { y: firstStage.y + HALF_SEPARATION_DISTANCE }

    return {
        sharedProperties,
        props3,
        props2,
        props1
    }
}

export function getDrift(rocket) {
    const { firstStage, secondStage, thirdStage, heights, offsets, resolution } = rocket

    const sharedProperties = {
        duration: ROCKET_STAGE_DRIFT_DURATION
    }

    const d = (heights[1] / resolution) + offsets[1]

    const target = {
        x: secondStage.x,
        y: secondStage.y + SEPARATION_DISTANCE + (firstStage.height * 0.5)
    }

    const props3 = {
        x: target.x,
        y: target.y - d
    }

    const props2 = {
        x: target.x,
        y: target.y
    }

    const props1 = {
        x: firstStage.x + DRIFT_TARGET.x,
        y: firstStage.y + DRIFT_TARGET.y,
        rotation: firstStage.rotation + DRIFT_ROTATION_RADIANS
    }

    return {
        sharedProperties,
        props3,
        props2,
        props1
    }
}

export function getDriftLoop(rocket) {
    const { firstStage } = rocket

    return {
        duration: ROCKET_STAGE_DRIFT_DURATION,
        x: firstStage.x + DRIFT_TARGET.x,
        y: firstStage.y + DRIFT_TARGET.y,
        rotation: firstStage.rotation + DRIFT_ROTATION_RADIANS
    }
}
